import { combineReducers } from 'redux';

// Reducers
import EmissionsDemoReducer from 'components/emissions-demo/reducer';
import ForecastDemoReducer from 'components/forecast-demo/reducer';
import RetinaDemoReducer from 'components/retina-demo/reducer';
import AtmoDemoReducer from 'components/atmo-demo/reducer';
import LoginFormReducer from 'components/login-form/reducer';
import LoginRequestReducer from 'components/login-request/reducer';

const rootReducer = combineReducers({
  emissionsDemo: EmissionsDemoReducer,
  forecastDemo: ForecastDemoReducer,
  retinaDemo: RetinaDemoReducer,
  atmoDemo: AtmoDemoReducer,
  authentication: LoginFormReducer,
  loginRequest: LoginRequestReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js